import { gql } from "@apollo/client";

export const QUERY_GET_ALL_TRANSDUCTIONS = gql`
  query QUERY_GET_ALL_TRANSDUCTIONS {
    transductionsHistory(order_by: {created_at: desc}) {
        created_at
        doctorId
        id
        patientId
        title
        transduction
        transductionTemplated
        url
        user {
        email
        name
        lastname
      }
    }
  }
`;

export const QUERY_GET_TRANSDUCTIONS_BY_PATIENT = gql`
  query QUERY_GET_TRANSDUCTIONS_BY_PATIENT($patientId: uuid) {
    transductionsHistory(order_by: {created_at: desc}, where: {patientId: {_eq: $patientId}}) {
      created_at
      doctorId
      id
      patientId
      title
      transduction
      transductionTemplated
      url
      user {
        email
        name
        lastname
      }
    }
  }
`;
